import React from 'react'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { Text, If, Button } from 'src/Components'

// Hooks
import { useViewListingShowPageUrl } from 'src/hooks/listings'

// Utils
import Format from 'src/Components/shared/Format'

// Styles
import baseStyles from '../ListingsCarousel.module.scss'
import styles from './Slide.module.scss'

const Slide = listing => {
  const {
    id,
    mainPhoto,
    formattedPrice,
    bedrooms,
    bathrooms,
    livingAreaSqFt,
    pocketAmount,
    mortgagePaymentDifference,
    className,
  } = listing

  const listingUrl = useViewListingShowPageUrl(listing)
  const formattedSqFt = livingAreaSqFt
    ? `${Format.number(livingAreaSqFt)} sqft`
    : ''

  return (
    <Button.ExternalListingsButton
      key={id}
      className={classnames(baseStyles.buttonParent, className)}
      listingsUrl={listingUrl}
    >
      <div
        className={styles.listingImageContainer}
        style={{ backgroundImage: `url(${mainPhoto})` }}
      />
      <div className={styles.listingDataContainer}>
        <div className={styles.listingPriceTextRow}>
          <Text
            weight='bold'
            size='xl'
            variant='neutralCool'
            variantCount='900'
          >
            {formattedPrice}
          </Text>
        </div>
        <div>
          <div className={styles.bedBathSqftTextRow}>
            <Text
              className={styles.bedBathSqft}
              variant='neutralCool'
              variantCount='700'
            >
              {bedrooms}bd
            </Text>
            <Text
              className={styles.bedBathSqft}
              variant='neutralCool'
              variantCount='700'
            >
              {bathrooms}ba
            </Text>
            <Text
              className={styles.bedBathSqft}
              variant='neutralCool'
              variantCount='700'
            >
              {formattedSqFt}
            </Text>
          </div>
          <If condition={pocketAmount && mortgagePaymentDifference}>
            <div className={styles.calculationsContainer}>
              <div className={styles.pocketAmountContainer}>
                <Text
                  className={styles.pocketAmountText}
                  variant='neutralCool'
                  variantCount='700'
                  size='xxs'
                  element='div'
                >
                  <FormattedMessage
                    id='MarketSpotLight.equitySmartSearch.pocket'
                    defaultMessage='POCKET'
                  />
                </Text>
                <Text
                  className={styles.pocketAmount}
                  size='l'
                  variant='success'
                  variantCount='700'
                >
                  <Format.Currency value={pocketAmount} abbreviate />
                </Text>
              </div>
              <If condition={mortgagePaymentDifference < 0}>
                <div className={styles.mortgagePaymentDifferenceContainer}>
                  <Text
                    className={styles.savingsText}
                    size='xxs'
                    element='div'
                    variant='neutralCool'
                    variantCount='600'
                  >
                    <FormattedMessage
                      id='MarketSpotLight.equitySmartSearch.save'
                      defaultMessage='SAVE ABOUT'
                    />
                  </Text>
                  <div className={styles.savingsContainer}>
                    <Text
                      className={styles.savingsAmount}
                      size='l'
                      variant='success'
                      variantCount='700'
                    >
                      <Format.Currency
                        value={Math.abs(mortgagePaymentDifference)}
                        abbreviate
                      />
                    </Text>
                    <Text
                      className={classnames(
                        styles.savingsAmount,
                        styles.savingsMonth
                      )}
                      size='s'
                      variant='success'
                      variantCount='700'
                    >
                      /mo
                    </Text>
                  </div>
                </div>
              </If>
              <If condition={mortgagePaymentDifference >= 0}>
                <div className={styles.mortgagePaymentDifferenceContainer}>
                  <Text
                    className={styles.savingsText}
                    size='xxs'
                    element='div'
                    variant='neutralCool'
                    variantCount='700'
                  >
                    <FormattedMessage
                      id='MarketSpotLight.equitySmartSearch.aboutAnExtra'
                      defaultMessage='ABOUT AN EXTRA'
                    />
                  </Text>
                  <div className={styles.savingsContainer}>
                    <Text
                      className={styles.savingsAmount}
                      size='l'
                      variant='danger'
                      variantCount='700'
                    >
                      <Format.Currency
                        value={Math.abs(mortgagePaymentDifference)}
                        abbreviate
                      />
                    </Text>
                    <Text
                      className={classnames(
                        styles.savingsAmount,
                        styles.savingsMonth
                      )}
                      size='s'
                      variant='danger'
                      variantCount='700'
                    >
                      /mo
                    </Text>
                  </div>
                </div>
              </If>
            </div>
          </If>
        </div>
      </div>
    </Button.ExternalListingsButton>
  )
}

export default Slide
